// import * as types from './mutation-types'
import axios from 'axios';
import Config from '../config/config.js';
import Cookie from 'js-cookie';
import store from '../store/index'
// axios 配置
axios.defaults.timeout = 20000
axios.defaults.baseURL = Config.baseUrl
axios.defaults.headers['spl-token'] = Cookie.get('spl-token');

export default {
    // 请求后台购物车数据初始化本地购物车
    initCart(context) {
        axios.get("/getCartData")
        .then(function(res) {
            console.log(res.data);
            context.commit('initCart', res.data.data)
        })
        .catch(function(err) {
            console.log(err);
        })
    },
    // 加入购物车
    addGoods(context, params) {
        if(params.goods.unit == '桶'){
            var good_num = parseInt(params.goods.good_num);
        }
        else if(params.goods.unit == '吨') {
            var good_num = parseFloat(params.goods.good_num);
        }
        var sendObj = {
            style: params.style,
            user_id: params.user_id,
            warehouse_id: params.warehouse_id,
            good_num: good_num,
            good_id: params.goods.good_id
        }
        axios.post("shopping_cart", JSON.stringify(sendObj))
        .then(res => {
            console.log(params);
            params.callback({
                'type': 'success',
                'message': res.data.msg
            })
            context.commit('addGoods', params.goods);
        })
        .catch(function(err) {
            console.log(err);
        })
    },
    // 从购物车减少商品
    reduceGoods(context, params) {
        axios.get("/reduceGoods", {
            params: {
                params
            }
        })
        .then(function(res) {
            console.log('减少购物车中商品');
            context.commit('reduceGoods', params);
        })
        .catch(function(err) {
            console.log(err);
        })
    },
    // 从购物车移除商品
    deleteGoods(context, params) {
        axios.get("/deleteGoods", {
            params: {
                params
            }
        })
        .then(function(res) {
            console.log('删除购物车中商品');
            context.commit('deleteGoods', params);
        })
        .catch(function(err) {
            console.log(err);
        })
    },
    // 选择商品
    selectGoods(context, goodsItem) {
        console.log('actions-selectGoods')
        context.commit('selectGoods', goodsItem.index);
    },
    // 初始化用户信息
    initUser(context) {
        axios.get("/getUserData")
        .then(function(res) {
            console.log("同步用户信息");
            context.commit('initUser', res.data.data);
        })
        .catch(function(err) {
            console.log(err);
        })
    },
    checkAll(context, checkAllFlag) {
        console.log('checkAllFlag');
        context.commit('checkAll', checkAllFlag);
    },
    toggleDelBtn(context, delFlag) {
        context.commit('toggleDelBtn', delFlag);
    },
    delGoods(context) {
        context.commit('delGoods');
    },
}



// WEBPACK FOOTER //
// ./src/store/actions.js